<template>
  <section class="newTable">
    <table class="table datatable table-striped area-list-datatable" id="InfoAdjustmentTable">
      <thead>
        <tr>
          <th :width="screenWidth * 0.08">
            <div class="checkbox checkbox-inline mr-0">
              <input
                @click="clickTarget = clickTarget == `clickAll`? `clickAll-again`: `clickAll`"
                type="checkbox"
                name="check-all"
                id="check-all"
                value="1"
                v-model="checkAll"
              />
              <label for="check-all"></label>
            </div>
            <span>#</span>
          </th>
          <th
            :width="screenWidth * 0.08"
            :class="'sorting ' + (order.fieldName == 'name' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('name')"
          >姓名</th>
          <th
            :width="screenWidth * 0.1"
            :class="'sorting ' + (order.fieldName == 'id' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('id')"
          >身分證</th>
          <th
            :width="screenWidth * 0.1"
            :class="'sorting ' + (order.fieldName == 'is_trn' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('is_trn')"
          >網路服務資格</th>
          <th :width="screenWidth * 0.11">項目</th>
          <th :width="screenWidth * 0.12">錯誤/共用明細查詢</th>
          <th
            :width="screenWidth * 0.14"
            :class="'sorting ' + (order.fieldName == 'is_done' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('is_done')"
          >完成狀態</th>
          <th
            :width="screenWidth * 0.12"
            :class="'sorting ' + (order.fieldName == 'remind_msg' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('remind_msg')"
          >提醒事項</th>
          <th width="*">回報</th>
        </tr>
      </thead>
      <tbody class="block-height" :style="{height: height + 'px'}">
        <tr v-for="(d, did) in tableDataBackup" :key="`InfoAdjustmentTable-table-td-${d.id}`">
          <td :width="screenWidth * 0.08">
            <div style="min-height: 30px;">
              <div class="mr-0 checkbox checkbox-inline">
                <input
                  @click="clickTarget = clickTarget == `td-${did}`? `td-${did}-again`: `td-${did}`"
                  type="checkbox"
                  name="`td-item[]`"
                  :id="`PrecisionMarketingDataTable-check-${did}`"
                  :value="d.id"
                  v-model="selection"
                  :disabled="d.id === ''"
                  @change="$emit('update', selection)"
                />
                <label :for="`PrecisionMarketingDataTable-check-${did}`"></label>
              </div>

              <span>
                <span class="no">{{did + 1}}</span>
                <span class="info text-center">
                  <level :lv="Number(d.vip_lv)" />
                  <avatar :gender="Number(d.sex)" :size="20" />
                </span>
              </span>
            </div>
          </td>
          <td :width="screenWidth * 0.08">
            <Tooltip :position="did < 3 ?'bottom':'top'" :name="d.name" :id="d.id">
              <a
                v-if="d.is_exist"
                @click.prevent="routerToCust(d.id, d.name)"
                class="link text-underline"
              >{{d.name | getMaskName}}</a>
              <a v-else>{{d.name | getMaskName}}</a>
            </Tooltip>
          </td>
          <td :width="screenWidth * 0.1">{{d.id | getMaskID}}</td>
          <td :width="screenWidth * 0.1">
            <span style="color:red;" v-if="d.is_trn=='未申辦'">{{d.is_trn}}</span>
            <span v-else>{{d.is_trn}}</span>
          </td>
          <td :width="screenWidth * 0.11">
            <span style="color:red;" v-if="d.mobl_adj_item_name && d.mobl_adj_item_code=='1'">
              {{d.mobl_adj_item_name}}
              <br />
            </span>
            <span
              v-if="d.mobl_adj_item_name && d.mobl_adj_item_code!='1' && d.mobl_adj_item_code!='0'"
            >
              {{d.mobl_adj_item_name}}
              <br />
            </span>
            <span style="color:red;" v-if="d.mail_adj_item_name && d.mail_adj_item_code=='1'">
              {{d.mail_adj_item_name}}
              <br />
            </span>
            <span
              v-if="d.mail_adj_item_name && d.mail_adj_item_code!='1' && d.mail_adj_item_code!='0'"
            >
              {{d.mail_adj_item_name}}
              <br />
            </span>
            <span style="color:red;" v-if="d.addr_adj_item_name && d.addr_adj_item_code=='1'">
              {{d.addr_adj_item_name}}
              <br />
            </span>
            <span
              v-if="d.addr_adj_item_name && d.addr_adj_item_code!='1' && d.addr_adj_item_code!='0'"
            >
              {{d.addr_adj_item_name}}
              <br />
            </span>
          </td>
          <td :width="screenWidth * 0.12">
            <button
              type="button"
              class="btn btn-primary"
              @click="$emit('Info-Adjustment-Detail', d)"
              v-html="'<span style=\'font-size:1rem\'>明細查詢<span>'"
            ></button>
          </td>
          <td :width="screenWidth * 0.14">
            <span v-if="d.reply_date||d.mobl_eft_date||d.email_eft_date||d.addr_eft_date">
              <span v-if="d.mobl_eft_date">
                手機 {{d.mobl_eft_date| dateFormat}}已變更
                <br />
              </span>
              <span v-if="d.email_eft_date">
                Email{{d.email_eft_date| dateFormat}}已變更
                <br />
              </span>
              <span v-if="d.addr_eft_date">地址{{d.addr_eft_date| dateFormat}}已變更</span>
              <span v-if="d.reply_date">{{d.reply_date| dateFormat}}已回報</span>
            </span>
            <span v-else>未完成</span>
          </td>
          <td :width="screenWidth * 0.12">
            {{d.remind_msg}}
          </td>
          <td width="*">
            <button
              type="button"
              class="btn btn-primary"
              @click="$emit('Visit-For-InfoAJ', d)"
            >
              <span style="font-size:1.25rem">填寫</span>
            </button>
          </td>
        </tr>
        <tr v-if="tableDataBackup.length == 0">
          <td colspan="8" class="text-center pt-3 pb-5">
            <h3>無客戶名單資料</h3>
          </td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Level from "@/components/Level";
import Avatar from "@/components/Avatar";
import { commonMixin } from "@/mixins/common";
import { setTimeout } from "timers";
import moment from "moment";
import Tooltip from "@/desktop/components/ToolTip";
const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad
let idmarkWidth = 148;
if (is_iPad) {
  idmarkWidth = 131;
}

export default {
  name: "InfoAdjustmentTable",
  mixins: [commonMixin],
  components: { Level, Avatar, Tooltip },
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    height: {
      type: Number,
      default: () => {
        return 350;
      }
    }
  },
  data() {
    return {
      order: {
        fieldName: "name",
        asc: true
      },
      dtData: [],
      checkAll: false,
      clickTarget: "",
      tableDataBackup: [],
      allIdData: [],
      selection: [],
      currentWidth: 0,
      is_iPad: is_iPad,
      iPadWidth: idmarkWidth,
      postUrl: "",
      today: "",
      screenWidth:
        document.body.clientWidth > 1208 ? 1280 : document.body.clientWidth,
      scrollHeight: 0
    };
  },
  watch: {
    tableData: function() {
      this.init();
    },
    clickTarget: function(target) {
      if (target == "clickAll" || target == "clickAll-again") {
        //點了全選checkbox
        if (this.checkAll) {
          //點了全選
          this.selection = [];
          this.allIdData.forEach(data => {
            this.selection.push(data);
          });
        } else {
          //取消全選
          this.selection = [];
        }
      } else {
        //點了其他checkbox
        this.checkAll = this.selection.length == this.allIdData.length;
      }
      this.$emit("update", this.selection);
    }
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    isBox() {
      //判斷是否為box
      return this.UserInfo.userType === "box";
    }
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    dateFormat(val) {
      // 轉換為民國
      if (val) {
        let dataAry = val.split("-");
        dataAry[0] = dataAry[0] * 1 - 1911 + "";
        return dataAry.join("-");
      }
      return "";
    },
    columnSorting(fieldName) {
      //切換表頭圖案
      if (this.order.fieldName == fieldName) {
        this.order.asc = !this.order.asc;
      } else {
        this.order.fieldName = fieldName;
        this.order.asc = true;
      }

      //data排序
      let sortOrder = -1;
      if (this.order.asc) {
        sortOrder = 1;
      }
      switch (fieldName) {
        case "name":
          this.tableDataBackup = [];
          this.$emit("get-Data", sortOrder);
          break;
        default:
          this.tableDataBackup = [];
          setTimeout(() => {
            this.tableDataBackup = [...this.tableData];
            this.tableDataBackup.sort(
              this.sortCompareFun(sortOrder, fieldName)
            );
            this.registerHanlink(); // for 難字更新
          }, 20);
      }
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    routerToCust(custID, custName) {
      if (this.isBox) {
        //若?嵌於Box, 將客戶資訊回傳給Box
        this.boxCustInfo(custID, custName);
      } else {
        this.updateCustID(custID);
        localStorage.CustID = custID;
        this.$router.push({ path: `/detail/CustID/tab/1` });
      }
    },
    init() {
      this.checkAll = false;
      this.selection = [];
      this.today = moment().format("YYYY-MM-DD");
      this.tableDataBackup = this.tableData.map(ele => {
        return ele;
      });
      this.allIdData = this.tableData.map(ele => {
        return ele.id;
      });
      // for 難字更新
      this.registerHanlink(); 
    }
  },
  mounted() {
    // 監聽視窗寬度
    const self = this;

    window.onresize = () => {
      return (() => {
        if (document.body.clientWidth > 1220) {
          window.screenWidth = 1220;
          self.screenWidth = 1220;
        } else {
          window.screenWidth = document.body.clientWidth;
          self.screenWidth = window.screenWidth;
        }
      })();
    };

    this.scrollHeight =
      parseInt($(window).height()) - $("tbody").offset().top - 85;
    $(window).bind("resize", function() {
      self.scrollHeight =
        parseInt($(window).height()) - $("tbody").offset().top - 85;
    });
    $(".tab-content").css("padding-bottom", "62px");
  }
};
</script>

<style lang="scss" scoped>
.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;

  td {
    word-break: break-all;
  }

  &.sorting,
  &.sorting_desc {
    position: relative;
    padding-right: 25px !important;

    &:before,
    &:after {
      content: "";
      position: absolute;
      width: 0px;
      height: 0px;
      display: block;
      top: 0;
      bottom: 0;
      right: 6px;
      margin: auto;
    }

    &:after {
      top: 18px;
      border-top: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }

    &:before {
      top: -13px;
      border-bottom: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid transparent;
    }
  }

  &.sorting_asc:before {
    border-bottom: 6px solid transparentize(white, 0.5);
  }

  &.sorting_desc:after {
    border-top: 6px solid transparentize(white, 0.5);
  }

  &.no-sort:before,
  &.no-sort:after {
    display: none;
  }
}

.newTable tbody.block-height {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}
</style>
